import { PasswordStrengthEnum } from "./types";

export const getIndicatorColorByPasswordStrength = (
  indicator: number,
  passwordStrengthValue: PasswordStrengthEnum
) => {
  switch (indicator) {
    case 0: {
      switch (passwordStrengthValue) {
        case PasswordStrengthEnum.WEAK: {
          return "$error500";
        }
        case PasswordStrengthEnum.MEDIUM: {
          return "$warning500";
        }
        case PasswordStrengthEnum.STRONG: {
          return "$success500";
        }
        default:
          return "$backgroundLight300";
      }
    }
    case 1: {
      switch (passwordStrengthValue) {
        case PasswordStrengthEnum.WEAK: {
          return "$backgroundLight300";
        }
        case PasswordStrengthEnum.MEDIUM: {
          return "$warning500";
        }
        case PasswordStrengthEnum.STRONG: {
          return "$success500";
        }
        default:
          return "$backgroundLight300";
      }
    }

    case 2: {
      switch (passwordStrengthValue) {
        case PasswordStrengthEnum.WEAK: {
          return "$backgroundLight300";
        }
        case PasswordStrengthEnum.MEDIUM: {
          return "$warning500";
        }
        case PasswordStrengthEnum.STRONG: {
          return "$success500";
        }
        default:
          return "$backgroundLight300";
      }
    }
    case 3: {
      switch (passwordStrengthValue) {
        case PasswordStrengthEnum.WEAK: {
          return "$backgroundLight300";
        }
        case PasswordStrengthEnum.MEDIUM: {
          return "$backgroundLight300";
        }
        case PasswordStrengthEnum.STRONG: {
          return "$success500";
        }
        default:
          return "$backgroundLight300";
      }
    }
    case 4: {
      switch (passwordStrengthValue) {
        case PasswordStrengthEnum.WEAK: {
          return "$backgroundLight300";
        }
        case PasswordStrengthEnum.MEDIUM: {
          return "$backgroundLight300";
        }
        case PasswordStrengthEnum.STRONG: {
          return "$success500";
        }
        default:
          return "$backgroundLight300";
      }
    }
  }
};
